import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import {
  ProspectActivity,
  BlastengineMailCampaignMailClickProspectActivity,
} from 'api';
import {Link} from 'react-router-dom';
import {MailCampaign} from 'components/Ui/Icon';

interface BlastengineMailCampaignMailClickActivity extends ProspectActivity {
  resource: BlastengineMailCampaignMailClickProspectActivity;
}

interface Props {
  prospectActivity: BlastengineMailCampaignMailClickActivity;
}

export default ({prospectActivity}: Props) => {
  const {
    resource: {
      mailCampaignSend = {},
      mailCampaignSendShortUrl = {},
      mailCampaignUrl = {},
    } = {},
  } = prospectActivity;

  const url = mailCampaignSendShortUrl?.urlPlaceholder || mailCampaignUrl?.url;

  return (
    <>
      <MailCampaign />
      <div className="flex-1 ml-2.5">
        <div className="flex items-center min-h-[30px]">
          <h3 className="flex-1 m-0 text-primary font-bold">
            <Link
              target="_blank"
              to={`/pools/${mailCampaignSend.mailCampaign.pool.uuid}/mail_campaigns/${mailCampaignSend.mailCampaign.uuid}`}>
              {mailCampaignSend.mailCampaign.title}
            </Link>
          </h3>
          <time className="text-text-2 ml-3.5">
            {moment(prospectActivity.createdAt).format('YYYY/MM/DD HH:mm')}
          </time>
        </div>
        <div className="flex text-text-2 w-full">
          <a
            href={url}
            target="_blank"
            className="max-w-[450px] overflow-hidden whitespace-nowrap text-ellipsis">
            {url}
          </a>
        </div>
      </div>
    </>
  );
};
